const actions = {
  GET_STATUS_REQUEST: "STATUS/GET_STATUS_REQUEST",
  GET_STATUS_SUCCESS: "STATUS/GET_STATUS_SUCCESS",
  GET_STATUS_ERROR: "STATUS/GET_STATUS_ERROR",

  GET_STATUS_BY_SCREEN_REQUEST: "STATUS/GET_STATUS_BY_SCREEN_REQUEST",
  GET_STATUS_BY_SCREEN_SUCCESS: "STATUS/GET_STATUS_BY_SCREEN_SUCCESS",
  GET_STATUS_BY_SCREEN_ERROR: "STATUS/GET_STATUS_BY_SCREEN_ERROR",

  fetchAllStatus: () => ({type: actions.GET_STATUS_REQUEST}),

  fetchStatusesByScreen: (payload) => ({
    type: actions.GET_STATUS_BY_SCREEN_REQUEST,
    payload,
  }),
};

export default actions;
